import React, { Component } from 'react';
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { isEmpty, size } from "lodash";

import { withRouter } from 'react-router-dom';
import { isSessionSwitchInProgress } from '../common/sessionSwitchUtils';
import FullScreenLoader from '../common/FullScreenLoader';

import { 
    fetchUserSpendings, 
    newSpending,
    updateUserSpending,
    deleteSpending } from '../../store/actions/spendingAction'
import { fetchAdminSpendingsDemand } from '../../store/actions/spendingDemandAction'
    
import { fetchParentCategories, fetchChildCategories } from '../../store/actions/categoriesAction'
import { fetchLabels } from '../../store/actions/labelsAction'
import {         updateUser,
    updateUserPassword,
} from '../../store/actions/userAction'
import { 
    // fetchArticles,
    fetchCurrentSession,
    // newUserDemand,
    // updateUserDemand,
    // fetchUserDemands,
} from '../../store/actions/demandAction'
import { fetchUserLoans, newLoanDemand, fetchUserLoanDemands, updateResaLoanUser, updateDemandLoanStatusUser, updateLoanDemand, deleteLoanDemand } from '../../store/actions/loanAction'

export default function(ComposedComponent) {

    class MustBeAuth extends Component {
        state = { 
            isSwitching: isSessionSwitchInProgress()
        }
        componentDidMount() {
            if(this.props.isEmployee) {
                this.props.history.push('/employee')
            } else if (!this.props.isAuthenticated) {
                this.props.history.push('/login')
            } else if(this.props.isAuthenticated) {
                if(!this.props.STATE.sessions.fetched){
                    this.props.fetchCurrentSession()
                }
                if(isEmpty(this.props.SPENDINGS) ){
                    this.props.fetchSpendings()
                }
                if(isEmpty(this.props.CATEGORIES.PARENT)){
                    this.props.fetchParentCategories()
                }
                if(isEmpty(this.props.CATEGORIES.CHILD)){
                    this.props.fetchChildCategories()
                }
            }
        }
        componentDidUpdate(prevProps) {
            // Vérifier si le changement de session est terminé
            const wasSwitching = this.state.isSwitching;
            const isSwitching = isSessionSwitchInProgress();
            if (wasSwitching && !isSwitching) {
                this.setState({ isSwitching: false });
            } else if (!wasSwitching && isSwitching) {
                this.setState({ isSwitching: true });
            }

            if(this.props.isEmployee && !prevProps.isEmployee) {
                this.props.history.push('/employee')
            } else if(!this.props.isAuthenticated && prevProps.isAuthenticated) {
                this.props.history.push('/login')
            }
        }
        render() {
            // Ne pas rendre le composant pendant le changement de session
            if (this.state.isSwitching) {
                return <FullScreenLoader open={true} message="Changement de compte en cours..." />;
            }
            return (
                <ComposedComponent {...this.props} />
            );
        }
    }
    
    MustBeAuth.propTypes = {
        isAuthenticated : PropTypes.bool.isRequired
    }

    function mapStateToProps(state){
        return {
            isAuthenticated : state.auth.isAuthenticated,
            isEmployee : state.auth.isEmployee,
            isSuper: state.auth.isSuperAdmin,
            user: state.auth.userInfo,
            SPENDINGS: state.spendings.USER,
            SPENDING_DEMANDS: state.spendingDemands.ADMIN,
            CATEGORIES: state.categories,
            LABELS: state.labels,
            CURRENT_SESSION: state.sessions.CURRENT,
            // ARTICLES: state.articles,
            STATE: state.request,
            LOANS: state.loans.USER,
            LOAN_DEMANDS: state.loanDemands.USER,


        }
    }

    function mapDispatchToProps(dispatch){
        return bindActionCreators({
            fetchSpendings: fetchUserSpendings,
            newSpending,
            updateUserSpending,
            deleteSpending,
            fetchParentCategories,
            fetchChildCategories,
            updateUser,
            updateUserPassword,    
            fetchCurrentSession,
            fetchUserLoans,
            newLoanDemand,
            fetchUserLoanDemands,
            updateResaLoanUser,
            updateDemandLoanStatusUser,
            updateLoanDemand,
            deleteLoanDemand,
            fetchAdminSpendingsDemand,
            fetchLabels,
            // newUserDemand,
            // updateUserDemand,
            // fetchUserDemands,
            // fetchArticles,
        }, dispatch)
    }

    return connect(mapStateToProps, mapDispatchToProps)(withRouter(MustBeAuth))
}